import { callGetExternalApi } from '@ctn/axios-util';

import { processError } from '@/utils/axiosErrors';
import axiosInstance from '@/utils/axiosInterceptor';

const getBackendUrl = () => ({
	GET_DATA_NUM_MESSAGE: '/notificaciones/contador/no-leidas',
});

const getMessages = async () =>
	callGetExternalApi<number>({ axiosInstance, withCredentials: true, url: getBackendUrl().GET_DATA_NUM_MESSAGE, processError });

export { getMessages };
